import { Button } from 'components/Button/Button';
import { Image } from 'components/Image/Image';
import { useState } from 'react';
import { useReferralCodeQuery } from 'lib/react-query/Queries/useReferralCodeQuery';
import { Referral } from '../Referral/referral';

const PromotionCard = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const { data: referralCodeData, isLoading: isReferralCodeLoading } =
    useReferralCodeQuery();
  const referralCode = referralCodeData?.result?.code;

  const copyReferralCode = async () => {
    if (!referralCode) return;

    try {
      await navigator.clipboard.writeText(referralCode);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    } catch {
      // noop
    }
  };

  return (
    <div className="bg-light-600 border border-light-800 rounded-md flex flex-col">
      <Image
        path="booking/finish-page/promotion-card.png"
        alt="Young people on the back of a truck in the countryside"
        className="rounded-t-md h-44"
      />
      <div className="p-5 flex flex-col">
        <div className="font-semibold text-xl text-teal-800 text-center mb-2.5">
          GET 100, GIVE 100!
        </div>
        <p className="font-medium text-sm leading-5 text-dark-700 mb-5">
          Help a friend save 100 on their trip when they book using your code
          and you'll receive 100 Global Dollars to spend on trips, flights &
          tours!
        </p>
        {isReferralCodeLoading ? (
          <div className="mb-5 mx-auto w-full max-w-[18rem] bg-light-600 rounded-md text-center">
            <div className="animate-pulse rounded-md bg-light-800 h-5 w-32 mx-auto mb-1"></div>
            <div className="animate-pulse rounded-md bg-light-800 h-8 w-40 mx-auto"></div>
          </div>
        ) : referralCode ? (
          <div className="mb-5 mx-auto w-full max-w-[18rem] bg-light-600 rounded-md text-center">
            <div className="text-dark-700 text-[1rem] leading-6 font-medium">
              Your referral code:
            </div>
            <button
              type="button"
              onClick={copyReferralCode}
              className="w-full text-dark-800 text-[1.5rem] leading-8 font-semibold tracking-[0.02em] cursor-pointer"
            >
              {referralCode}
            </button>
            <div
              className={
                'text-[0.75rem] leading-4 text-teal-800 transition-opacity duration-200 ' +
                (isCopied ? 'opacity-100' : 'opacity-0')
              }
            >
              Copied
            </div>
          </div>
        ) : null}
        <Button
          text="Share My Code"
          clickHandler={() => setIsOpen(true)}
          size="medium"
          className="w-full py-2"
        />
        {isOpen ? <Referral isOpen={isOpen} setIsOpen={setIsOpen} /> : null}
      </div>
    </div>
  );
};

export { PromotionCard };
